import type { NormalizedApiError } from "~/store/middleware/normalizeApiError";

export interface TrialLimitClassification {
	cap: number | null;
	current: number | null;
	limit: string | null;
}

// wsapi emits code TRIAL_LIMIT_REACHED with limit/cap/current extensions (TrialLimitsGate)
const TRIAL_LIMIT_REACHED_CODE = "TRIAL_LIMIT_REACHED";

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null && !Array.isArray(value);

const readCount = (value: unknown): number | null =>
	typeof value === "number" && Number.isFinite(value) ? value : null;

const readLimit = (value: unknown): string | null => {
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	return trimmed.length > 0 ? trimmed : null;
};

const classifyTrialLimitError = (normalized: NormalizedApiError): TrialLimitClassification | null => {
	const errors = normalized.graphqlErrors;
	if (!errors) return null;

	for (const error of errors) {
		const extensions = error.extensions;
		if (!isRecord(extensions)) continue;
		if (extensions.code !== TRIAL_LIMIT_REACHED_CODE) continue;
		return {
			cap: readCount(extensions.cap),
			current: readCount(extensions.current),
			limit: readLimit(extensions.limit)
		};
	}

	return null;
};

export default classifyTrialLimitError;
